/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Cart,
  CartModificationList,
  ErrorList,
  OrderEntryList,
} from '../models';
import {
    CartFromJSON,
    CartToJSON,
    CartModificationListFromJSON,
    CartModificationListToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
    OrderEntryListFromJSON,
    OrderEntryListToJSON,
} from '../models';

export interface DoAddOrgCartEntriesRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    orderEntryList: OrderEntryList;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetCurrentOrgCartRequest {
    baseSiteId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceOrgCartCostCenterRequest {
    baseSiteId: string;
    cartId: string;
    costCenterId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceOrgCartDeliveryAddressRequest {
    addressId: string;
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceOrgCartEntriesRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    orderEntryList: OrderEntryList;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceOrgCartPaymentTypeRequest {
    baseSiteId: string;
    cartId: string;
    paymentType: string;
    userId: string;
    fields?: string;
    purchaseOrderNumber?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface SetOrgPaymentModeRequest {
    baseSiteId: string;
    cartId: string;
    paymentModeCode: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

/**
 * B2BCartsApi - interface
 * 
 * @export
 * @interface B2BCartsApiInterface
 */
export interface B2BCartsApiInterface {
    /**
     * Creates additional quantity of a product in the cart. Use this endpoint to add the quantities of the existing products. To update the products’ quantities or add new products to the cart, use PUT /{baseSiteId}/orgUsers/{userId}/carts/{cartId}/entries/
     * @summary Creates additional quantity of a product in the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {OrderEntryList} orderEntryList 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    doAddOrgCartEntriesRaw(requestParameters: DoAddOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>>;

    /**
     * Creates additional quantity of a product in the cart. Use this endpoint to add the quantities of the existing products. To update the products’ quantities or add new products to the cart, use PUT /{baseSiteId}/orgUsers/{userId}/carts/{cartId}/entries/
     * Creates additional quantity of a product in the cart.
     */
    doAddOrgCartEntries(requestParameters: DoAddOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList>;

    /**
     * Retrieves the current cart.  To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * @summary Gets the current cart.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    getCurrentOrgCartRaw(requestParameters: GetCurrentOrgCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>>;

    /**
     * Retrieves the current cart.  To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Gets the current cart.
     */
    getCurrentOrgCart(requestParameters: GetCurrentOrgCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart>;

    /**
     * Updates the cost center for the cart during the checkout process.
     * @summary Updates the cost center for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} costCenterId Cost center identifier.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    replaceOrgCartCostCenterRaw(requestParameters: ReplaceOrgCartCostCenterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>>;

    /**
     * Updates the cost center for the cart during the checkout process.
     * Updates the cost center for the cart.
     */
    replaceOrgCartCostCenter(requestParameters: ReplaceOrgCartCostCenterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart>;

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * @summary Updates the delivery address for a cart.
     * @param {string} addressId The id of the address.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    replaceOrgCartDeliveryAddressRaw(requestParameters: ReplaceOrgCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>>;

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * Updates the delivery address for a cart.
     */
    replaceOrgCartDeliveryAddress(requestParameters: ReplaceOrgCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart>;

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * @summary Updates the quantity of the specified products in a cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {OrderEntryList} orderEntryList 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    replaceOrgCartEntriesRaw(requestParameters: ReplaceOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>>;

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * Updates the quantity of the specified products in a cart.
     */
    replaceOrgCartEntries(requestParameters: ReplaceOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList>;

    /**
     * Updates the payment type for the cart during the checkout process. If the purchaseOrderNumber is not null, it will also be updated for the cart.
     * @summary Updates the payment type for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} paymentType Payment type choice. Examples:card,account
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [purchaseOrderNumber] Purchase order number to assign to the cart during the checkout process.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    replaceOrgCartPaymentTypeRaw(requestParameters: ReplaceOrgCartPaymentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>>;

    /**
     * Updates the payment type for the cart during the checkout process. If the purchaseOrderNumber is not null, it will also be updated for the cart.
     * Updates the payment type for the cart.
     */
    replaceOrgCartPaymentType(requestParameters: ReplaceOrgCartPaymentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart>;

    /**
     * Set payment mode on cart
     * @summary Set payment mode on cart
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier
     * @param {string} paymentModeCode 
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BCartsApiInterface
     */
    setOrgPaymentModeRaw(requestParameters: SetOrgPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Set payment mode on cart
     * Set payment mode on cart
     */
    setOrgPaymentMode(requestParameters: SetOrgPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class B2BCartsApi extends runtime.BaseAPI implements B2BCartsApiInterface {

    /**
     * Creates additional quantity of a product in the cart. Use this endpoint to add the quantities of the existing products. To update the products’ quantities or add new products to the cart, use PUT /{baseSiteId}/orgUsers/{userId}/carts/{cartId}/entries/
     * Creates additional quantity of a product in the cart.
     */
    async doAddOrgCartEntriesRaw(requestParameters: DoAddOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling doAddOrgCartEntries.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling doAddOrgCartEntries.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling doAddOrgCartEntries.');
        }

        if (requestParameters.orderEntryList === null || requestParameters.orderEntryList === undefined) {
            throw new runtime.RequiredError('orderEntryList','Required parameter requestParameters.orderEntryList was null or undefined when calling doAddOrgCartEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/carts/{cartId}/entries/`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderEntryListToJSON(requestParameters.orderEntryList),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationListFromJSON(jsonValue));
    }

    /**
     * Creates additional quantity of a product in the cart. Use this endpoint to add the quantities of the existing products. To update the products’ quantities or add new products to the cart, use PUT /{baseSiteId}/orgUsers/{userId}/carts/{cartId}/entries/
     * Creates additional quantity of a product in the cart.
     */
    async doAddOrgCartEntries(requestParameters: DoAddOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList> {
        const response = await this.doAddOrgCartEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current cart.  To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Gets the current cart.
     */
    async getCurrentOrgCartRaw(requestParameters: GetCurrentOrgCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCurrentOrgCart.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getCurrentOrgCart.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/current`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * Retrieves the current cart.  To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Gets the current cart.
     */
    async getCurrentOrgCart(requestParameters: GetCurrentOrgCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.getCurrentOrgCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the cost center for the cart during the checkout process.
     * Updates the cost center for the cart.
     */
    async replaceOrgCartCostCenterRaw(requestParameters: ReplaceOrgCartCostCenterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceOrgCartCostCenter.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceOrgCartCostCenter.');
        }

        if (requestParameters.costCenterId === null || requestParameters.costCenterId === undefined) {
            throw new runtime.RequiredError('costCenterId','Required parameter requestParameters.costCenterId was null or undefined when calling replaceOrgCartCostCenter.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceOrgCartCostCenter.');
        }

        const queryParameters: any = {};

        if (requestParameters.costCenterId !== undefined) {
            queryParameters['costCenterId'] = requestParameters.costCenterId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/costcenter`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * Updates the cost center for the cart during the checkout process.
     * Updates the cost center for the cart.
     */
    async replaceOrgCartCostCenter(requestParameters: ReplaceOrgCartCostCenterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.replaceOrgCartCostCenterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * Updates the delivery address for a cart.
     */
    async replaceOrgCartDeliveryAddressRaw(requestParameters: ReplaceOrgCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.addressId === null || requestParameters.addressId === undefined) {
            throw new runtime.RequiredError('addressId','Required parameter requestParameters.addressId was null or undefined when calling replaceOrgCartDeliveryAddress.');
        }

        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceOrgCartDeliveryAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceOrgCartDeliveryAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceOrgCartDeliveryAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.addressId !== undefined) {
            queryParameters['addressId'] = requestParameters.addressId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/carts/{cartId}/addresses/delivery`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * Updates the delivery address for a cart.
     */
    async replaceOrgCartDeliveryAddress(requestParameters: ReplaceOrgCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.replaceOrgCartDeliveryAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * Updates the quantity of the specified products in a cart.
     */
    async replaceOrgCartEntriesRaw(requestParameters: ReplaceOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceOrgCartEntries.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceOrgCartEntries.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceOrgCartEntries.');
        }

        if (requestParameters.orderEntryList === null || requestParameters.orderEntryList === undefined) {
            throw new runtime.RequiredError('orderEntryList','Required parameter requestParameters.orderEntryList was null or undefined when calling replaceOrgCartEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/carts/{cartId}/entries/`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderEntryListToJSON(requestParameters.orderEntryList),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationListFromJSON(jsonValue));
    }

    /**
     * Adds specific products or overwrites the details of existing products in the cart, based either on the product code or the entry number. For existing products, attributes not provided in the request body will be defined again (set to null or default).
     * Updates the quantity of the specified products in a cart.
     */
    async replaceOrgCartEntries(requestParameters: ReplaceOrgCartEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList> {
        const response = await this.replaceOrgCartEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the payment type for the cart during the checkout process. If the purchaseOrderNumber is not null, it will also be updated for the cart.
     * Updates the payment type for the cart.
     */
    async replaceOrgCartPaymentTypeRaw(requestParameters: ReplaceOrgCartPaymentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceOrgCartPaymentType.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceOrgCartPaymentType.');
        }

        if (requestParameters.paymentType === null || requestParameters.paymentType === undefined) {
            throw new runtime.RequiredError('paymentType','Required parameter requestParameters.paymentType was null or undefined when calling replaceOrgCartPaymentType.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceOrgCartPaymentType.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.paymentType !== undefined) {
            queryParameters['paymentType'] = requestParameters.paymentType;
        }

        if (requestParameters.purchaseOrderNumber !== undefined) {
            queryParameters['purchaseOrderNumber'] = requestParameters.purchaseOrderNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/paymenttype`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * Updates the payment type for the cart during the checkout process. If the purchaseOrderNumber is not null, it will also be updated for the cart.
     * Updates the payment type for the cart.
     */
    async replaceOrgCartPaymentType(requestParameters: ReplaceOrgCartPaymentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.replaceOrgCartPaymentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set payment mode on cart
     * Set payment mode on cart
     */
    async setOrgPaymentModeRaw(requestParameters: SetOrgPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling setOrgPaymentMode.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling setOrgPaymentMode.');
        }

        if (requestParameters.paymentModeCode === null || requestParameters.paymentModeCode === undefined) {
            throw new runtime.RequiredError('paymentModeCode','Required parameter requestParameters.paymentModeCode was null or undefined when calling setOrgPaymentMode.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setOrgPaymentMode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/orgUsers/{userId}/carts/{cartId}/payment-mode/{paymentModeCode}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"paymentModeCode"}}`, encodeURIComponent(String(requestParameters.paymentModeCode))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set payment mode on cart
     * Set payment mode on cart
     */
    async setOrgPaymentMode(requestParameters: SetOrgPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setOrgPaymentModeRaw(requestParameters, initOverrides);
    }

}
